import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useLocalizedLink } from '../../hooks/useLocalizedLink'

function Breadcrumb({ title, description, bgImage }) {
    const { t } = useTranslation()
    const getLocalizedPath = useLocalizedLink()
    
    // Tüm sayfalarda aynı breadcrumb banner görselini kullan
    const defaultBreadcrumbImage = '/assets/img/yurt-fotograf/breadcrumb-banner.png'
    
    return (
        <>
            <div
                className="breadcumb-wrapper "
                style={{ backgroundImage: `url(${bgImage || defaultBreadcrumbImage})`, backgroundRepeat:"no-repeat", backgroundSize:"cover" }}
                role="img"
                aria-label={`Haseki Sultan Kız Öğrenci Yurdu - ${title}`}
                title={`Haseki Sultan Kız Öğrenci Yurdu - ${title}`}
            >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{title}</h1>
                        <ul className="breadcumb-menu">
                            <li>
                                <Link to={getLocalizedPath("/")}>{t("nav.home")}</Link>
                            </li>
                            <li>{title}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </>

    )
}

export default Breadcrumb
